// Maps a listing's `sectionPage` value to its URL path segment + label.
// Used by detail routes, hub links, breadcrumbs and the import script.
export const SECTIONS = {
  'Eat & Drink': { path: 'eat-drink', label: 'Eat & Drink' },
  'Where to Stay': { path: 'where-to-stay', label: 'Where to Stay' },
  Surf: { path: 'surf', label: 'Surf' },
}

// path segment -> sectionPage value (reverse lookup for [slug] routes)
export const PATH_TO_SECTION = Object.fromEntries(
  Object.entries(SECTIONS).map(([section, v]) => [v.path, section])
)

export const sectionPath = (sectionPage) => SECTIONS[sectionPage]?.path || 'explore'
